import React, { FC } from 'react';
import cx from 'clsx';
import { makeStyles, Theme } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow, { TableRowProps } from '@material-ui/core/TableRow';
import { ColumnProps } from './LwtTable';
import { sumBy } from 'lodash';

const useStyles = makeStyles<Theme>((theme: Theme) => {
  return {
    firstCell: {
      width: '200px',
      fontSize: '0.95rem',
      fontWeight: 600,
      paddingRight: 0,
      paddingLeft: theme.spacing(1.5)
    }
  };
});

export interface RowProps extends Omit<TableRowProps, 'children'> {
  data: Array<any>;
  columns: ColumnProps<any>[];
}

const TableSummaryRow: FC<RowProps> = ({ data, columns }) => {
  const classes = useStyles();

  return (
    <TableRow className={cx(classes.noBorder)}>
      {columns.map((col, idx) => {
        return (
          <TableCell key={`${col.label}_${idx}-table-row-data`} className={cx(classes.firstCell)}>
            {col.summaryLabel
              ? col.summaryLabel.toUpperCase()
              : col.summaryKey
              ? sumBy(data, col.summaryKey)
              : null}
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export default TableSummaryRow;
